export function msCalciatori(data) {
    const output = {};
  
    for (let key in data.calciatori) {
      if (data.calciatori.hasOwnProperty(key)) {
        // Create new key with "_" prefix
        const newKey = `_${key}`;
  
        // Extract and restructure the "ms2" property
        const ms2 = data.calciatori[key].ms2;
  
        // Assign the new structure to the output object
        output[newKey] = {
          ms: {
            text: ms2.text,
            style: ms2.style,
            icon: ms2.icon
          }
        };
      }
    }
    // delete output['_3174'];
    // console.log(output)
    return output;
  }

export function listoneConf(data) {
  const listone = data && data.listone ? data.listone : {};

  return {
    status: listone.status,
    tsExpected: listone.expected_timestamp,
  };
}

export function tipiMercatiLega(data) {
  const tipiMercati = data && Array.isArray(data.tipiMercati)
    ? data.tipiMercati
    : [];

  return tipiMercati.map(normalizeTipoMercato);
}

function normalizeTipoMercato(tipoMercato = {}) {
  const statiMercatiOptions = Array.isArray(tipoMercato.statiMercatiOptions)
    ? tipoMercato.statiMercatiOptions.map((option) => ({
      id: option.id !== undefined ? parseInt(option.id) : undefined,
      text: option.text,
      html: option.html,
      description: option.description,
      color: option.color,
    }))
    : [];

  return {
    id: tipoMercato.id !== undefined ? parseInt(tipoMercato.id) : undefined,
    text: tipoMercato.text,
    description: tipoMercato.description,
    statoMercato:
      tipoMercato.statoMercato !== undefined
        ? parseInt(tipoMercato.statoMercato)
        : undefined,
    statiMercatiOptions,
  };
}
